import angular from 'angular';

import deleteElementDialog from '../../../DeleteElementModal/deleteElement';
import sectionsLibraryService from '../../SectionsLibrary/SectionsLibraryService';
import toolbarService from '../../Toolbar/ToolbarService';
import AnchorModal from  '../AnchorModal/AnchorModal';

import gettext from 'angular-gettext';

const workspaceElement = {
    bindings: {
        section: '<',
        sections: '<',
        context: '<',
        workspaceType: '<',
        sectionsNested: '<',
        content: '=',
        options: '<'
    },
    template: require('./workspace-element.html'),
    controller: function (
        dragulaService,
        SectionsLibraryService,
        ToolbarService,
        $scope,
        deleteElementDialog,
        gettextCatalog,
        ClickOutside,
        $uibModal,
        UniqueIdGenerator,
        AnchorModal,
        $rootScope,
        $timeout
    ) {
        /** @ngInject() */

        let dragularListener;

        this.$onInit = () => {

            if(!this.section.config) {
                this.onFocus(this.section);
            }

            clearSectionKeys(this.section);

          this.dragularScope = this.context.getDragularScope();

            if (this.section.type !== 'pageSection' &&
               this.workspaceType === 'workspace' &&
               this.sectionsNested
            ) {
                wrapElementInSection(this.section);
            }

            this.sectionDefinition = SectionsLibraryService.getSectionDefinition(this.section.type);

        };

        /**
         * Check if section has "disableRemove" flag
         * @returns {boolean}
         */
        this.isRemoveDisabled = () => {
            return this.sectionDefinition && this.sectionDefinition.options ? this.sectionDefinition.options.disableRemove : false;
        };

        /**
         * Check if section has "disableCopy" flag
         * If not, check if child sections have this option
         * @returns {boolean}
         */
        this.isCopyDisabled = () => {
            let selfDisabled = this.sectionDefinition && this.sectionDefinition.options ? this.sectionDefinition.options.disableCopy : false;
            let childrenDisabled = false;

            if(!selfDisabled && this.section && this.section.config && this.section.config.children) {
                this.section.config.children.forEach(column => {
                    column.forEach(subSection => {
                        if(subSection) {
                            let childConfig = SectionsLibraryService.getSectionDefinition(subSection.type);
                            if (childConfig && childConfig.options && childConfig.options.disableCopy) {
                                childrenDisabled = true;
                            }
                        }
                    });
                });
            }

            return selfDisabled || childrenDisabled;
        };

        this.onFocus = (section, $event) => {

            if($event) {
              $event.stopPropagation();
            }

            this.context.setCurrentElement(section);

            $timeout(() => {
                    $rootScope.$broadcast('creator-workspace-selection-changed')
                }
            );

            if(this.context.isClickOutsideEnabled()) {
                $scope.$broadcast('creator-workspace-focus', {section: section});
                ClickOutside.setCurrent('section-element', () => {
                    this.context.clearCurrentElement();
                    $scope.$apply();
                    $scope.$broadcast('creator-workspace-blur');
                }, 'disable-click-outside');
            }
        };

        this.isSelected = (section) => {
            return this.context.getCurrentElement() === section;
        };

        this.removeSection = (section, $event) => {
            $event.stopPropagation();
            let position = this.findPosition(section);
            this.sections.splice(position, 1);
            this.context.clearCurrentElement();

            $scope.$emit('content-changed');
        };

        this.copySection = (event, section) => {
            event.stopPropagation();
            let copiedSection = angular.copy(section);
            let position = this.findPosition(section) + 1;
            if (copiedSection.config && copiedSection.config.key) {
                copiedSection.config.key = copiedSection.type + Math.floor(Math.random() * (Math.pow(2, 30) - 1) + 1);
            }

            this.regenerateUid(copiedSection);

            if (copiedSection.config && copiedSection.config.sectionId) {
                copiedSection.config.sectionId = UniqueIdGenerator.generate(copiedSection.type);
            }
            if (copiedSection.config && copiedSection.config.children) {
                copiedSection.config.children.forEach(column => {
                    column.forEach(element => {
                        if(element.config && element.config.sectionId) {
                            element.config.sectionId = UniqueIdGenerator.generate(element.type);
                        }
                    })
                });

            }
            this.sections.splice(position, 0, copiedSection);
            this.onFocus(this.sections[position]);

            $scope.$emit('content-changed');
        };

        this.regenerateUid = (section) => {
            if(section.config && section.config.uid) {
                section.config.uid = UniqueIdGenerator.generate('element-uid');
            }
            if(section.config && section.config.children) {
                section.config.children.forEach((column) => {
                    column.forEach(subSection => {
                        if(subSection.config && subSection.config.uid) {
                            subSection.config.uid = UniqueIdGenerator.generate('element-uid');
                        }
                    })
                })
            }
        };

        this.findPosition = (section) => {
            let position = -1;

            this.sections.forEach((el, key) => {

                if (el.$$hashKey === section.$$hashKey) {
                    position = key;
                }
            });
            return position;
        };

        /**
         * Wrap child section in section container
         * @param elementToWrap
         */
        let wrapElementInSection = (elementToWrap) => {

            let copy = angular.copy(elementToWrap);

            let wrapped = {
                type: 'pageSection',
                group: 'page',
                config: ToolbarService.getSectionDefaultSchema('pageSection')
            };

            clearSectionKeys(elementToWrap);
            wrapped.config.children = [[copy]];
            wrapped.config.columnsWidth = [12];
            angular.merge(elementToWrap, wrapped);

        };


        let clearSectionKeys = (element) => {
            Object.keys(element).forEach(key => {
                if (['type', 'group', 'config', '$$hashKey'].indexOf(key) === -1) {
                    delete element[key];
                }
            });
        };

        this.showAnchorModal = (section) => {
            AnchorModal.open(section);
        };

        this.moveUp = (section) => {
            let position = this.findPosition(section);
            if(position > 0) {
                let movedSection = this.sections[position - 1];
                this.sections[position - 1] = section;
                this.sections[position] = movedSection;
                $scope.$emit('content-changed');
            }
        };

        this.moveDown = (section) => {
            let position = this.findPosition(section);
            if(position < this.sections.length) {
                let movedSection = this.sections[position + 1];
                this.sections[position + 1] = section;
                this.sections[position] = movedSection;
                $scope.$emit('content-changed');
            }
        };

        $scope.$on('$destroy', ()=> {
            if(dragularListener) {
                dragularListener();
            }
        });

    }
};

export default angular.module('cms.creator.workspace-element', [
    deleteElementDialog,
    sectionsLibraryService,
    toolbarService,
    gettext,
    AnchorModal
]).component('workspaceElement', workspaceElement).name;



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/Workspace/WorkspaceElement/WorkspaceElement.js